import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import crypto from 'crypto-js';

import * as LoginActions from './actions';

import SignupPage from './SignupPage';

const SignupContainer = ({
  dispatch,
  contracts,
  accounts,
  transactions,
  transactionStack,
  blockTxHash,
  accountChanged,
  granting,
  willCommit,
  committing
}) => {
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.TkgGoldBuyingAndSelling;

  const [ userInfo, setUserInfo ] = useState({
    userIdDigest: null,
    passwordDigest: null
  });
  const [ signupInvalid, setSignupInvalid ] = useState(false);

  const [ signupConfirms, setSignupConfirms ] = useState(false);
  const [ signupConfirming, setSignupConfirming ] = useState(false);

  const [ data, setData ] = useState({ emailAddress: "", password: "" });
  const [ stackId, setStackId ] = useState(null);

  const userAddr = 0;
  const [ savedAccount, setSavedAccount ] = useState(accounts[userAddr]);
  const [ dataKey, setDataKey ] = useState(null);
  // For Sepolia
  const encryptedJson = {
    "version": 3,
    "id": "5301c8ce-4213-436f-af5d-06b6a2ef505a",
    "address": "1392ef24b278f91db7f9c1f0edbe902736d0dd63",
    "crypto": {
      "ciphertext": "f03d77562cc066bbd328616d5c03144006a45faa92238a88d7b2b7c6db26f7b9",
      "cipherparams": {
        "iv": "814087276f901480e38cfc1a872d652f"
      },
      "cipher": "aes-128-ctr",
      "kdf": "scrypt",
      "kdfparams": {
        "dklen": 32,
        "salt": "fda66b98fcd52a98083d534b00c37614616e08f1c794dcf8605e8f4b6c5e7b30",
        "n": 8192,
        "r": 8,
        "p": 1
      },
      "mac": "8d74dcc1ff9facd1f07b7676850b0a8739c209d9c6872b56c979a3cdc4e4ccdf"
    }
  };
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");

  // For Ganache
  /*const encryptedJson = {
    version: 3,
      id: 'f83c2efa-812e-4e46-b896-634fc346e642',
      address: '220e9eeacbcd69f6a45f7a9fe007cc2049ff2666',
      crypto: {
        ciphertext: '15c1b488057b0af28ccceafaf023d0a24ffa715c8658bfe4f6699b7ac5f94603',
        cipherparams: { iv: 'd2407ebbfb64fb6a3e59dd961e33e013' },
        cipher: 'aes-128-ctr',
        kdf: 'scrypt',
        kdfparams: {
          dklen: 32,
          salt: 'e790536fab67825818d28b48016356036fd614868d96ddd7c964b7c603f69d02',
          n: 8192,
          r: 8,
          p: 1
        },
        mac: '85a01602788578beb75d736a1b31608ff4e5e42c5f41f39d4779e9e03e57cdf9'
     }
  };
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");*/

  // The second address for Sepolia
  /*const encryptedJson = {
    version: 3,
    id: '8127803d-c3df-4741-8e39-58c285fc6c1a',
    address: 'c5b4a38b4327c9891ded517e8f042fcbc49309d3',
    crypto: {
      ciphertext: 'dfecbce8cb9b0e301d899286ace1dc312d1f4714be9fce197b1c8add6fc557c9',
      cipherparams: { iv: '2cb2275836647327fd1f179e92805b8b' },
      cipher: 'aes-128-ctr',
      kdf: 'scrypt',
      kdfparams: {
        dklen: 32,
        salt: 'fa4f6f17bb8f0dfceb8c46e49bf4613fb741524c98558ab825ff5e72a876fec9',
        n: 8192,
        r: 8,
        p: 1
      },
      mac: 'a1cd986b85b32276792e62608078f145a5000331be406dfbb6517fb58f632e7a'
    }
  }
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");*/

  const Decrypt = () => {
    const encryptedHexStr = crypto.enc.Hex.parse(word);
    const srcs = crypto.enc.Base64.stringify(encryptedHexStr);
    const decrypt = crypto.AES.decrypt(srcs, key, { iv: iv, mode: crypto.mode.CBC, padding: crypto.pad.Pkcs7 });
    const decryptedString = decrypt.toString(crypto.enc.Utf8);
    return decryptedString.toString();
  };

  const handleConfirmSubmit = () => {
    setSignupConfirms(true);
    setSignupConfirming(false);
  };

  const handleCancelSubmit = () => {
    setSignupConfirms(false);
    setSignupConfirming(false);
  };

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (data.emailAddress === "" || data.password === "" || !data.emailAddress.match(/[^@]+@[^@]+/)) {
      setSignupInvalid(true);
      e.target.reset();
      return;
    }

    const emailAddress = data.emailAddress;
    const password = data.password;
    const confirmedPassword = data.confirmedPassword;

    if (password === confirmedPassword) {
      setUserInfo({
        userIdDigest: drizzle.web3.utils.sha3(emailAddress),
        passwordDigest: drizzle.web3.utils.sha3(password)
      });
    } else {
      setSignupInvalid(true);
      e.target.reset();
      return;
    }
    setSignupConfirming(true);
    e.target.reset();
  };

  useEffect(() => {
    if ((userInfo.userIdDigest === null && userInfo.passwordDigest === null) || !signupConfirms)
      return;

    initializeAccount();
  }, [signupConfirms]);

  const initializeAccount = async () => {
    var _dataKey = await contract.methods.checkBalance.cacheCall(savedAccount);

    setDataKey(_dataKey);
  };

  const checkBalance = async () => {
    if (granting || willCommit || committing || dataKey === null)
      return;

    const isBalance = contracts.TkgGoldBuyingAndSelling.checkBalance[dataKey]
      ? contracts.TkgGoldBuyingAndSelling.checkBalance[dataKey].value
      : null

    if (isBalance === null)
      return;

    if (isBalance) {
      var pk = drizzle.web3.eth.accounts.decrypt(encryptedJson, Decrypt());
      await drizzle.web3.eth.accounts.wallet.add(pk.privateKey);
      pk = null;
      setDataKey(null);
      dispatch(notifyChangedAddress(drizzle.web3))
    } else {
      setDataKey(null);
      dispatch(willCommitSignup());
    }
    return;
  }

  useEffect(() => {
    checkBalance();
  }, [dataKey, contracts]);

  useEffect(() => {
    if (!willCommit)
      return;

    commitSignup();
  }, [willCommit]);

  useEffect(() => {
    const noEth = 1;
    const hasEth = 2;

    if (!accountChanged)
      return;
    else if (accountChanged === noEth)
      grantEth();
    else if (accountChanged === hasEth)
      commitSignup();
  }, [accounts]);

  const grantEth = async () => {
    const ceoAddr = 0;
    const estimatedGas = await contract.methods.grantAtFirstAccess(
        savedAccount
      ).estimateGas({
        from: accounts[ceoAddr]
    });
    
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.3;
    const gasPriceMultiplication = 2.4;

    const _stackId = await contract.methods["grantAtFirstAccess"].cacheSend(savedAccount, {
      from: accounts[ceoAddr],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
    })
    dispatch(notifyGranting());
    setStackId(_stackId);
  };

  const commitSignup = async () => {
    const userAddr = 0;

    const estimatedGas = await contract.methods.commitSignup(
        userInfo.userIdDigest, userInfo.passwordDigest
      ).estimateGas({
        from: accounts[userAddr]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.3;
    const gasPriceMultiplication = 2.4;

    const _stackId = await contract.methods["commitSignup"].cacheSend(
      userInfo.userIdDigest, userInfo.passwordDigest, {
      from: accounts[userAddr],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
    });
    setStackId(_stackId);
    dispatch(notifySigningUp());
  };

  useEffect(() => {
    if (!granting || committing)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'success') {
      var pk = drizzle.web3.eth.accounts.decrypt(encryptedJson, Decrypt());
      drizzle.web3.eth.accounts.wallet.remove(pk.address);
      dispatch(notifyRecoverAddress(drizzle.web3));
      pk = null;

      dispatch(notifyGranted());
      return;
    }
  }, [transactions]);

  useEffect(() => {
    if (granting || !committing)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'success') {
      dispatch(notifySignedgUp());
      return;
    }
  }, [transactions]);

  return (
    <SignupPage
      signupInvalid={signupInvalid}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      signupConfirms={signupConfirms}
      signupConfirming={signupConfirming}
      handleConfirmSubmit={handleConfirmSubmit}
      handleCancelSubmit={handleCancelSubmit}
    />
  );
}

const notifyGranting = () => {
  return {
    type: LoginActions.SIGNUP_GRANTING
  };
};

const notifyGranted = () => {
  return {
    type: LoginActions.SIGNUP_GRANTED
  };
};


const willCommitSignup = () => {
  return {
    type: LoginActions.SIGNUP_WILL_COMMIT
  }
}

const notifySigningUp = () => {
  return {
    type: LoginActions.SIGNUP_COMMITTING
  };
};

const notifySignedgUp = stackId => {
  return {
    type: LoginActions.SIGNUP_COMMITTED
  };
};

const notifyChangedAddress = web3 => {
  return {
    type: LoginActions.ACCOUNTS_CHANGED,
    web3: web3
  };
}

const notifyRecoverAddress = web3 => {
  return {
    type: LoginActions.ACCOUNTS_RECOVERED,
    web3: web3
  };
}

const mapStateToProps = state => ({
  contracts: state.contracts,
  accounts: state.accounts,
  transactions: state.transactions,
  transactionStack: state.transactionStack,
  blockTxHash: state.login.blockTxHash,
  accountChanged: state.login.accountChanged,
  granting: state.login.granting,
  willCommit: state.login.willCommit,
  committing: state.login.committing
});

export default connect(mapStateToProps)(SignupContainer);
